import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Accordion, Col, Row } from "react-bootstrap";
import { PanssParameters } from "../types/PanssParameters.type";
import { predictPanss } from "../services/PanssService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/useAuth";
import { PanssResult } from "../types/PanssResults.type";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import "../styles/Forms.css";
import InfoIcon from "./InfoIcon";

export default function PanssTest() {
  const [t, i18n] = useTranslation("global");
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  //const [customError, setCustomError] = useState("");
  const [isFEPChecked, setIsFEPChecked] = useState(false);
  const [loading, setLoading] = useState(false); // control the loading page and block the button upon submit

  // Handle toggole swith change
  const handleFEPChange = (e) => {
    setIsFEPChecked(e.target.checked);
  };

  const submitForm = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(e.target);
      const payload = Object.fromEntries(formData);
      // Check prePanssp fields
      const prePansspFields = [
        payload.prePanssp1,
        payload.prePanssp2,
        payload.prePanssp3,
        payload.prePanssp4,
        payload.prePanssp5,
        payload.prePanssp6,
        payload.prePanssp7,
      ].map(Number);

      const filledPrePansspFields = prePansspFields.filter(
        (field) => !isNaN(field) && field !== 0
      );

      // Check if any fields are filled
      const isAnyFieldFilled =
        filledPrePansspFields.length > 0 ||
        (!isNaN(Number(payload.prePanssP)) && Number(payload.prePanssP) !== 0);

      if (isAnyFieldFilled) {
        // If any of the prePanssp fields are filled, check if all seven fields are filled
        if (
          filledPrePansspFields.length > 0 &&
          filledPrePansspFields.length !== 7
        ) {
          alert("All prePanssp1 to prePanssp7 fields must be filled.");
          return;
        }

        // If all prePanssp fields are filled, check if their sum matches prePanssP (if prePanssP is provided)
        if (filledPrePansspFields.length === 7) {
          const prePansspSum = filledPrePansspFields.reduce(
            (sum, field) => sum + field,
            0
          );
          if (payload.prePanssP && prePansspSum !== Number(payload.prePanssP)) {
            alert("The sum of prePanssp1 to prePanssp7 must equal prePanssP.");
            return;
          }
        }
      }

      const result: PanssParameters = {
        //  Personal data
        Age: payload.age.toString(),
        Gender: payload.gender.toString(),
        Education: payload.edu.toString(),
        Marital: payload.marital.toString(),
        Living: payload.living.toString(),
        Employment: payload.employment.toString(),
        // Substances usage
        Alcohol: payload.alcohol === "on" ? "2" : "1",
        Caffeine: payload.caffeine === "on" ? "2" : "1",
        Illicite: payload.illicite === "on" ? "2" : "1",
        Cannabis: payload.cannabis === "on" ? "2" : "1",
        Tabacoo: payload.tabacoo === "on" ? "2" : "1",
        //  Illness information
        Diagnosis: payload.fep === "on" ? "5" : payload.diagnosis.toString(),
        Length_Illness: Number(payload.illnessLengthYears).toString(),
        //  Tests
        //      PANSS
        pre_panss_P: payload.prePanssP.toString(),
        pre_panss_N: payload.prePanssN.toString(),
        pre_panss_G: payload.prePanssG.toString(),
        pre_panss_T: (
          Number(payload.prePanssP) +
          Number(payload.prePanssN) +
          Number(payload.prePanssG)
        ).toString(),
        pre_panssp1: payload.prePanssp1.toString(),
        pre_panssp2: payload.prePanssp2.toString(),
        pre_panssp3: payload.prePanssp3.toString(),
        pre_panssp4: payload.prePanssp4.toString(),
        pre_panssp5: payload.prePanssp5.toString(),
        pre_panssp6: payload.prePanssp6.toString(),
        pre_panssp7: payload.prePanssp7.toString(),
        pre_panssg9: payload.prePanssg9.toString(),
        //      BCIS
        pre_BCIS_reflex: payload.preBCISReflex.toString(),
        pre_BCIS_certez: payload.preBCISCertez.toString(),
        //      Rosen
        pre_Rosen_total: payload.preRosenTotal.toString(),
        //      TMT
        pre_TMT_A_pd: payload.preTMTaPd.toString(),
        pre_TMT_B_pd: payload.preTMTbPd.toString(),
        //      GAF
        pre_gaf: payload.preGaf.toString(),
        //      PSYRATS
        pre_psy_haltotal: payload.prePsyAlTotal.toString(),
        pre_psy_deltotal: payload.prePsyDelTotal.toString(),
        //      Quality of Life (QoL)
        pre_gen_qol: payload.preGenQol.toString(),
        //      Jump to Conclusions (JTC)
        pre_jtc: payload.preJTC.toString(),
        //      Depression
        pre_Depression: payload.preDepression.toString(),
      };
      const res = await predictPanss(result);
      const panssResults: PanssResult = {
        /*PREDICTIONS*/
        prediction_P: res["prediction_P"],
        real_prediction_P: res["real_prediction_P"],
        prediction_del_artificial: res["prediction_del_artificial"],
        real_prediction_del_artificial: res["real_prediction_del_artificial"],
        prediction_psy_hal: res["prediction_psy_hal"],
        real_prediction_psy_hal: res["real_prediction_psy_hal"],
        prediction_psy_del: res["prediction_psy_del"],
        real_prediction_psy_del: res["real_prediction_psy_del"],
        prediction_rosentotal: res["prediction_rosentotal"],
        real_prediction_rosentotal: res["real_prediction_rosentotal"],
        prediction_bcis_total: res["prediction_bcis_total"],
        real_prediction_bcis_total: res["real_prediction_bcis_total"],
        prediction_bcisreflex: res["prediction_bcisreflex"],
        real_prediction_bcisreflex: res["real_prediction_bcisreflex"],
        prediction_bciscertez: res["prediction_bciscertez"],
        real_prediction_bciscertez: res["real_prediction_bciscertez"],
        completation: res["completation"],
        completion_prob: res["completion_prob"],
        /*PERCENTAGE DIFERENCE*/
        diference_perc_P: res["diference_perc_P"],
        diference_DEL_ARTIFICIAL: res["diference_DEL_ARTIFICIAL"],
        diference_PSY_HAL: res["diference_PSY_HAL"],
        diference_PSY_DEL: res["diference_PSY_DEL"],
        diference_ROSENTOTAL: res["diference_ROSENTOTAL"],
        diference_BCISTOTAL: res["diference_BCISTOTAL"],
        diference_BCISREFLEX: res["diference_BCISREFLEX"],
        diference_BCISCERTEZ: res["diference_BCISCERTEZ"],
        /*VERSION*/
        model_P_version: res["model_P_version"],
        model_P_explain_version: res["model_P_explain_version"],
        model_DEL_ARTIFICIAL: res["model_DEL_ARTIFICIAL"],
        model_DEL_ARTIFICIAL_explain: res["model_DEL_ARTIFICIAL_explain"],
        model_PSY_HAL_version: res["model_PSY_HAL_version"],
        model_PSY_HAL_explain_version: res["model_PSY_HAL_explain_version"],
        model_PSY_DEL_version: res["model_PSY_DEL_version"],
        model_PSY_DEL_explain_version: res["model_PSY_DEL_explain_version"],
        model_ROSENTOTAL_version: res["model_ROSENTOTAL_version"],
        model_ROSENTOTAL_explain_version:
          res["model_ROSENTOTAL_explain_version"],
        model_BCISREFLEX_version: res["model_BCISREFLEX_version"],
        model_BCISREFLEX_explain_version:
          res["model_BCISREFLEX_explain_version"],
        model_BCISCERTEZ_version: res["model_BCISCERTEZ_version"],
        model_BCISCERTEZ_explain_version:
          res["model_BCISCERTEZ_explain_version"],
        model_MTC_COMPLETION_version: res["model_MTC_COMPLETION_version"],
        model_MTC_COMPLETION_explain_version:
          res["model_MTC_COMPLETION_explain_version"],
        /*PRE DATA*/
        pre_panss_P: res["pre_panss_P"],
        pre_del_artifical: res["pre_del_artifical"],
        pre_psy_haltotal: res["pre_psy_haltotal"],
        pre_psy_deltotal: res["pre_psy_deltotal"],
        pre_Rosen_total: res["pre_Rosen_total"],
        pre_BCISTOTAL: res["pre_BCISTOTAL"],
        pre_BCIS_reflex: res["pre_BCIS_reflex"],
        pre_BCIS_certez: res["pre_BCIS_certez"],
        /*FORM INFO*/
        pre_Age: res["pre_Age"],
        pre_Gender: res["pre_Gender"],
        pre_Education: res["pre_Education"],
        pre_Marital: res["pre_Marital"],
        pre_Living: res["pre_Living"],
        pre_Employment: res["pre_Employment"],
        pre_Alcohol: res["pre_Alcohol"],
        pre_Caffeine: res["pre_Caffeine"],
        pre_Illicite: res["pre_Illicite"],
        pre_Cannabis: res["pre_Cannabis"],
        pre_Tabacoo: res["pre_Tabacoo"],
        pre_Diagnosis: res["pre_Diagnosis"],
        pre_Length_Illness: res["pre_Length_Illness"],
        pre_panssp1: res["pre_panssp1"],
        pre_panssp2: res["pre_panssp2"],
        pre_panssp3: res["pre_panssp3"],
        pre_panssp4: res["pre_panssp4"],
        pre_panssp5: res["pre_panssp5"],
        pre_panssp6: res["pre_panssp6"],
        pre_panssp7: res["pre_panssp7"],
        pre_panssg9: res["pre_panssg9"],
        pre_panss_N: res["pre_panss_N"],
        pre_panss_G: res["pre_panss_G"],
        pre_panss_T: res["pre_panss_T"],
        pre_TMT_A_pd: res["pre_TMT_A_pd"],
        pre_TMT_B_pd: res["pre_TMT_B_pd"],
        pre_gaf: res["pre_gaf"],
        pre_gen_qol: res["pre_gen_qol"],
        pre_jtc: res["pre_jtc"],
        pre_Depression: res["pre_Depression"],
        /*  SHAP    */
        pred_feature_names: res["pred_feature_names"],
        prediction_P_explain_vals: res["prediction_P_explain_vals"],
        prediction_P_explain_base: res["prediction_P_explain_base"],
        prediction_del_artificial_explain_vals: res["prediction_del_artificial_explain_vals"],
        prediction_del_artificial_explain_base: res["prediction_del_artificial_explain_base"],
        prediction_psy_hal_explain_vals: res["prediction_psy_hal_explain_vals"],
        prediction_psy_hal_explain_base: res["prediction_psy_hal_explain_base"],
        prediction_psy_del_explain_vals: res["prediction_psy_del_explain_vals"],
        prediction_psy_del_explain_base: res["prediction_psy_del_explain_base"],
        prediction_rosentotal_explain_vals: res["prediction_rosentotal_explain_vals"],
        prediction_rosentotal_explain_base: res["prediction_rosentotal_explain_base"],
        prediction_bcisreflex_explain_vals: res["prediction_bcisreflex_explain_vals"],
        prediction_bcisreflex_explain_base: res["prediction_bcisreflex_explain_base"],
        prediction_bciscertez_explain_vals: res["prediction_bciscertez_explain_vals"],
        prediction_bciscertez_explain_base: res["prediction_bciscertez_explain_base"],
        completion_explain_vals: res["completion_explain_vals"],
        completion_explain_base: res["completion_explain_base"],
      };
      navigate("results", {
        state: {
          panssResults,
        },
      });
    } catch (error) {
      console.error("Error en la predicción:", error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src="https://i.gifer.com/ZZ5H.gif"
            alt={t("buttons.loading")}
            style={{ width: "80px", height: "80px" }}
          />
        </div>
      )}
      <div className="d-flex justify-content-center mt-5">
        <Form validated={validated} className="w-75" onSubmit={submitForm}>
          <Accordion className="custom-accordion" defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {t("predictions.personal-data")}
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formAge">
                      <Form.Label>{t("predictions.age")}</Form.Label>
                      <Form.Control
                        className="custom-input"
                        name="age"
                        min={1}
                        type="number"
                        placeholder={t("predictions.placeholders.age")}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formGender">
                      <Form.Label>{t("predictions.gender")}</Form.Label>
                      <Form.Select
                        className="custom-select"
                        name="gender"
                        required
                      >
                        <option value="">
                          {t("predictions.placeholders.gender")}
                        </option>
                        <option value="1">{t("predictions.male")}</option>
                        <option value="2">{t("predictions.female")}</option>
                        <option value="">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formEdu">
                      <Form.Label>{t("predictions.edu")}</Form.Label>
                      <Form.Control
                        name="edu"
                        className="custom-input"
                        min={1}
                        type="number"
                        placeholder={t("predictions.placeholders.edu")}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formMarital">
                      <Form.Label>{t("predictions.marital-status")}</Form.Label>
                      <Form.Select
                        name="marital"
                        className="custom-select"
                        required
                      >
                        <option value="">
                          {t("predictions.placeholders.marital-status")}
                        </option>
                        <option value="1">{t("predictions.single")}</option>
                        <option value="2">{t("predictions.married")}</option>
                        <option value="3">{t("predictions.separated")}</option>
                        <option value="4">{t("predictions.widow")}</option>
                        <option value="5">{t("predictions.other")}</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formLiving">
                      <Form.Label>{t("predictions.living-status")}</Form.Label>
                      <Form.Select
                        className="custom-select"
                        name="living"
                        required
                      >
                        <option value="">
                          {t("predictions.placeholders.living-status")}
                        </option>
                        <option value="1">
                          {t("predictions.living-options.alone")}
                        </option>
                        <option value="2">
                          {t("predictions.living-options.resident")}
                        </option>
                        <option value="3">
                          {t("predictions.living-options.residence")}
                        </option>
                        <option value="4">
                          {t("predictions.living-options.other")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Form.Group className="mb-3" controlId="formEmployment">
                      <Form.Label>
                        {t("predictions.employment-status")}
                      </Form.Label>
                      <Form.Select
                        className="custom-select"
                        name="employment"
                        required
                      >
                        <option value="">
                          {t("predictions.placeholders.employment-status")}
                        </option>
                        <option value="1">
                          {t("predictions.employment-options.inactive")}
                        </option>
                        <option value="2">
                          {t("predictions.employment-options.active")}
                        </option>
                        <option value="3">
                          {t("predictions.employment-options.illness")}
                        </option>
                        <option value="4">
                          {t("predictions.employment-options.pensionist")}
                        </option>
                        <option value="5">
                          {t("predictions.employment-options.invalid")}
                        </option>
                        <option value="6">
                          {t("predictions.employment-options.others")}
                        </option>
                        <option value="7">
                          {t("predictions.employment-options.student")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>{t("predictions.drug-usage")}</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formCaffeine">
                      <Form.Label>{t("predictions.caffeine")}</Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="caffeine"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formTabacoo">
                      <Form.Label>{t("predictions.tabacoo")}</Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="tabacoo"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formAlcohol">
                      <Form.Label>{t("predictions.alchohol")}</Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="alcohol"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4}>
                    <Form.Group className="mb-3" controlId="formCannabis">
                      <Form.Label>{t("predictions.cannabis")}</Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="cannabis"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={4}>
                    <Form.Group className="mb-3" controlId="formIllicite">
                      <Form.Label>{t("predictions.illicite")}</Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="illicite"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                {t("predictions.illness-information")}
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col xs={10}>
                    <Form.Group className="mb-3" controlId="formDiagnosis">
                      <Form.Label>{t("predictions.diagnosis")}</Form.Label>
                      <Form.Select
                        className="custom-select"
                        name="diagnosis"
                        required
                        disabled={isFEPChecked}
                      >
                        <option value="">
                          {t("predictions.placeholders.diagnosis")}
                        </option>
                        <option value="1">
                          {t("predictions.diagnosis-options.schizophrenia")}
                        </option>
                        <option value="2">
                          {t("predictions.diagnosis-options.schizophreniform")}
                        </option>
                        <option value="3">
                          {t("predictions.diagnosis-options.schizoaffective")}
                        </option>
                        <option value="4">
                          {t("predictions.diagnosis-options.delusional")}
                        </option>
                        <option value="6">
                          {t("predictions.diagnosis-options.brief")}
                        </option>
                        <option value="7">
                          {t("predictions.diagnosis-options.other-psy")}
                        </option>
                        <option value="8">
                          {t("predictions.diagnosis-options.others")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="FEP">
                      <Form.Label>
                        {t("predictions.diagnosis-options.fep")}
                      </Form.Label>
                      <Form.Check
                        className="custom-check"
                        type="switch"
                        name="fep"
                        checked={isFEPChecked}
                        onChange={handleFEPChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={10}>
                    <Form.Group className="mb-3" controlId="formLengthIllness">
                      <Form.Label>
                        {t("predictions.illness-length")}
                        <InfoIcon infoText={t("infoText.illnessLength")} />
                      </Form.Label>
                      {/*<Row className="mb-3">*/}
                      <Form.Control
                        required
                        className="custom-input"
                        name="illnessLengthYears"
                        min={0}
                        step="0.1"
                        type="number"
                        placeholder={t(
                          "predictions.placeholders.illness-length.years"
                        )}
                      />
                      {/*</Row>*/}
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            {/*     PANSS       */}
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                {t("predictions.questionnaires")}
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Form.Group className="mb-3" controlId="formPrePanssp">
                    <Form.Label>{t("predictions.panss-positives")}</Form.Label>
                    <Row>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp1"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p1")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp2"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p2")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp3"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p3")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp4"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p4")}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp5"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p5")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp6"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p6")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssp7"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-p7")}
                        />
                      </Col>
                      <Col xs={3} className="mb-3">
                        <Form.Control
                          name="prePanssg9"
                          className="custom-input"
                          type="number"
                          min={1}
                          max={7}
                          placeholder={t("predictions.placeholders.panss-g9")}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-3" controlId="formPrePanssp">
                    <Form.Label>{t("predictions.panss-tests")}</Form.Label>
                    <Row>
                      <Col xs={4} className="mb-3">
                        <Form.Control
                          name="prePanssP"
                          className="custom-input"
                          min={7}
                          max={49}
                          type="number"
                          placeholder={t("predictions.placeholders.panss-p")}
                        />
                      </Col>
                      <Col xs={4} className="mb-3">
                        <Form.Control
                          name="prePanssN"
                          className="custom-input"
                          min={7}
                          max={49}
                          type="number"
                          placeholder={t("predictions.placeholders.panss-n")}
                        />
                      </Col>
                      <Col xs={4} className="mb-3">
                        <Form.Control
                          name="prePanssG"
                          className="custom-input"
                          type="number"
                          min={16}
                          max={112}
                          placeholder={t("predictions.placeholders.panss-g")}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
                {/*     BCIS        */}
                <Row>
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formBCIS">
                      <Form.Label>{t("predictions.bcis")}</Form.Label>
                      <Row className="mb-3">
                        <Form.Control
                          name="preBCISReflex"
                          className="custom-input"
                          min={0}
                          max={36}
                          type="number"
                          placeholder={t(
                            "predictions.placeholders.bcis-reflex"
                          )}
                        />
                      </Row>
                      <Row className="mb-3">
                        <Form.Control
                          name="preBCISCertez"
                          className="custom-input"
                          min={0}
                          max={24}
                          type="number"
                          placeholder={t(
                            "predictions.placeholders.bcis-certez"
                          )}
                        />
                      </Row>
                    </Form.Group>
                  </Col>
                  {/*     Rosen     */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPreRosenTotal">
                      <Form.Label>
                        {t("predictions.rosen")}
                        <InfoIcon infoText={t("infoText.rosen")} />
                      </Form.Label>
                      <Form.Control
                        name="preRosenTotal"
                        className="custom-input"
                        type="number"
                        min={10}
                        max={40}
                        placeholder={t("predictions.placeholders.rosen-total")}
                      />
                    </Form.Group>
                  </Col>
                  {/*     TMT     */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formTMT">
                      <Form.Label>
                        {t("predictions.tmt")}
                        <InfoIcon infoText={t("infoText.tmt")} />
                      </Form.Label>
                      <Row className="mb-3">
                        <Form.Control
                          name="preTMTaPd"
                          className="custom-input"
                          type="number"
                          min={0}
                          max={300}
                          placeholder={t("predictions.placeholders.tmt-a")}
                        />
                      </Row>
                      <Row className="mb-3">
                        <Form.Control
                          name="preTMTbPd"
                          className="custom-input"
                          type="number"
                          min={0}
                          max={300}
                          placeholder={t("predictions.placeholders.tmt-b")}
                        />
                      </Row>
                    </Form.Group>
                  </Col>
                  {/*     GAF     */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPreGaf">
                      <Form.Label>
                        {t("predictions.gaf")}
                        <InfoIcon infoText={t("infoText.gaf")} />
                      </Form.Label>
                      <Form.Control
                        name="preGaf"
                        className="custom-input"
                        type="number"
                        min={0}
                        max={100}
                        placeholder={t("predictions.placeholders.gaf")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {/*    PSY     */}
                  {/*    Hallucinations     */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPrePsy">
                      <Form.Label>{t("predictions.psy")}</Form.Label>
                      <Row className="mb-3">
                        <Form.Control
                          name="prePsyAlTotal"
                          className="custom-input"
                          type="number"
                          min={0}
                          max={44}
                          placeholder={t(
                            "predictions.placeholders.psy-al-total"
                          )}
                        />
                      </Row>
                      {/*    Delusions     */}
                      <Row className="mb-3">
                        <Form.Control
                          name="prePsyDelTotal"
                          className="custom-input"
                          type="number"
                          min={0}
                          max={24}
                          placeholder={t(
                            "predictions.placeholders.psy-del-total"
                          )}
                        />
                      </Row>
                    </Form.Group>
                  </Col>
                  {/*     Quality of Life (QoL)       */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPreGenQol">
                      <Form.Label>
                        {t("predictions.qol")}
                        <InfoIcon infoText={t("infoText.qol")} />
                      </Form.Label>
                      <Form.Select className="custom-select" name="preGenQol">
                        <option>
                          {t("predictions.placeholders.qol.title")}
                        </option>
                        <option value="0">
                          {t("predictions.placeholders.qol.low")}
                        </option>
                        <option value="1">
                          {t("predictions.placeholders.qol.middle")}
                        </option>
                        <option value="2">
                          {t("predictions.placeholders.qol.high")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {/*     JTC     */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPreJtc">
                      <Form.Label>
                        {t("predictions.jtc")}
                        <InfoIcon infoText={t("infoText.jtc")} />
                      </Form.Label>
                      <Form.Select className="custom-select" name="preJTC">
                        <option>
                          {t("predictions.placeholders.jtc.title")}
                        </option>
                        <option value="0">
                          {t("predictions.placeholders.jtc.negative")}
                        </option>
                        <option value="1">
                          {t("predictions.placeholders.jtc.affirmative")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {/*     Depression      */}
                  <Col xs={3} className="mb-3">
                    <Form.Group className="mb-3" controlId="formPreDepression">
                      <Form.Label>
                        {t("predictions.depression")}
                        <InfoIcon infoText={t("infoText.depression")} />
                      </Form.Label>
                      <Form.Select
                        className="custom-select"
                        name="preDepression"
                      >
                        <option>
                          {t("predictions.placeholders.depression.title")}
                        </option>
                        <option value="0">
                          {t("predictions.placeholders.depression.negative")}
                        </option>
                        <option value="1">
                          {t("predictions.placeholders.depression.affirmative")}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Button
            className="custom-button w-100 mt-5"
            variant="primary"
            type="submit"
            disabled={loading}
          >
            {t("buttons.submit")}
          </Button>
        </Form>
      </div>
    </>
  );
}
